"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeleteReview = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
const useDeleteReview = ({
  onDeleteConfirmDialogClose
}) => {
  const {
    customerId,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    reviewId,
    onClose: onRatingAndReviewDialogClose,
    onSuccessDelete
  } = (0, _contexts.useRatingAndReviewDialog)();
  const {
    onOpen: onResultDialogOpen
  } = (0, _contexts.useResultDialog)();
  return (0, _react.useCallback)(async () => {
    if (!isUserVerified || !reviewId) {
      return;
    }
    (0, _globalApiClientReact.deleteApplicationsCustomerFeedbackCustomerReview)(globalApiClient, String(customerId), String(reviewId), {
      [_constants.ACCEPT_LANGUAGE]: language,
      [_fetching.TENANT_CONTEXT]: tenant
    }).then(() => {
      onResultDialogOpen({
        header: translations.reviewWasDeleted
      });
      onSuccessDelete?.();
    }).catch(() => {
      onResultDialogOpen({
        content: translations.reviewFailDescription,
        header: translations.reviewFailTitle,
        severity: 'error'
      });
    }).finally(() => {
      onRatingAndReviewDialogClose();
      onDeleteConfirmDialogClose();
    });
  }, [isUserVerified, reviewId, globalApiClient, customerId, language, tenant, onDeleteConfirmDialogClose, translations.reviewWasDeleted, translations.reviewFailDescription, translations.reviewFailTitle, onSuccessDelete, onResultDialogOpen, onRatingAndReviewDialogClose]);
};
exports.useDeleteReview = useDeleteReview;
